import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate, useLocation } from "react-router";
import Constant from "../../../utils/constant";
import {
  IStandardGroup,
  IStandardGroupStandard,
  IStandardGroupStandardSearchRequest,
} from "../../../model/interface/standardGroup";
import { useForm } from "react-hook-form";
import Breadcrumb from "../../shared/common/breadcrumb";
import { IBreadcrumb } from "../../../model/interface/breadcrumb";
import Loader from "../../shared/loader/loader";
import constant from "../../../utils/constant";
import { DropdownItem } from "../../../model/interface/keyValuePair";
import Select from "react-select";
import { toast } from "react-toastify";
import {
  addNewStandard,
  getStandardGroup,
  getStandardGroupStandards,
  updateStandardGroup,
} from "../../../api/standardGroup.service";
import {
  AddIcon,
  CaretDownSolidIcon,
  CaretUpSolidIcon,
  FilterIcon,
  LinkIcon,
} from "../../../assets/icons";
import { IStandard } from "../../../model/interface/standard";
import SelectPageSize from "../../shared/common/pageSizeDropdown";
import Pagination from "../../shared/common/pagination";
import AllowedTo from "../../shared/common/rbac";
import Permissions from "../../../utils/permissions";
import AccessDenied from "../../shared/common/accessDenied";
import { useNumericParam } from "../../../utils/useNumericParam";

const ManageStandardGroup = (props: any) => {
  const defaultDropdownValues: DropdownItem = {
    label: "",
    value: "0",
  };
  const defaultPageNumber = 1;
  const defaultPageSize = 10;
  const id = useNumericParam("id");
  const idToEdit = id ? id : 0;
  const [standardGroupToEdit, setStandardGroupToEdit] =
    useState<IStandardGroup>();
  const [contentAreas, setContentAreas] = useState<DropdownItem[]>([]);
  const [subjects, setSubjects] = useState<DropdownItem[]>([]);
  const [domains, setDomains] = useState<DropdownItem[]>([]);
  const [standards, setStandards] = useState<IStandard[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [lang, setLang] = useState<number>(1);
  const [selectedContent, setSelectedContent] = useState<DropdownItem>(
    defaultDropdownValues
  );
  const [selectedSubject, setSelectedSubject] = useState<DropdownItem>(
    defaultDropdownValues
  );
  const [selectedDomain, setSelectedDomain] = useState<DropdownItem>(
    defaultDropdownValues
  );
  const [sortAscending, setSortAscending] = useState<boolean>(true);
  const [orderByColumn, setOrderByColumn] = useState<string>("");
  const [sortDir, setSortDir] = useState<string>("");
  const [filterStandardId, setFilterStandardId] = useState<number>();
  const [standardGroupStandardIds, setStandardGroupStandardIds] = useState<
    number[]
  >([]);
  const [selectedNames, setSelectedNames] = useState<any>([]);
  const [pageSize, setPageSize] = useState(defaultPageSize);
  const [pageNumber, setPageNumber] = useState(defaultPageNumber);
  const [totalPages, setTotalPages] = useState<number>(0);
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const paginationRef: any = useRef(undefined);
  const pageSizeRef: any = useRef(undefined);
  let successMessage: string;
  const [isLoaded, setIsLoaded] = useState<boolean>(false);
  const [isEdit, setIsEdit] = useState<boolean>(id ? true : false);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const navigate = useNavigate();

  const location = useLocation();
  const parameters = location.state as any;

  async function submitHandler(data: any) {
    setLoading(true);
    const standardGroup: IStandardGroup = {
      standardGroupId: idToEdit > 0 ? idToEdit : 0,
      name: data.name,
      subjectId: selectedSubject ? parseInt(selectedSubject.value) : 0,
      domainId: selectedDomain ? parseInt(selectedDomain.value) : 0,
      isActive: true,
      createdByUserId: props.profile?.userId == 0 ? 1 : props.profile?.userId,
    };

    if (idToEdit && idToEdit > 0) {
      standardGroup.standardGroupId = idToEdit;
      await updateStandardGroup(standardGroup);
      successMessage = "Standard Group updated successfully";
    }
    setLoading(false);
    toast.success(successMessage);

    if (parameters?.redirectBack) {
      navigate(-1);
    } else {
      navigate(Constant.STANDARDGROUPS);
    }
  }

  const breadcrumbItems = () => {
    const items: Array<IBreadcrumb> = [
      { name: "Standard Group", url: constant.STANDARDGROUPS },

      {
        name: id ? "Edit Standard Group" : "Add Standard Group",
        url: "",
      },
    ];

    if (id) {
      items.push({ name: id?.toString(), url: "" });
    }

    return items;
  };

  async function bindContentAreas(selectedItem?: DropdownItem) {
    setLoading(true);
    const service = await import("../../../api/contentArea.service");
    service.getContentArea().then((response) => {
      const result = response.data.data;
      const contentAreaData = result.map((item) => {
        return { label: item.name, value: item.contentAreaId };
      });
      setContentAreas(contentAreaData);
      if (selectedItem) {
        setSelectedContent(selectedItem);
      } else if (parameters?.autoFillData) {
        const selectedContentArea = contentAreaData.find((t) => {
          return t.value === parameters?.autoFillData.contentId;
        });
        setSelectedContent(selectedContentArea);
      }
      setLoading(false);
    });
  }

  async function bindSubjects(contentId: number, selectedItem?: DropdownItem) {
    setLoading(true);

    const service = await import("../../../api/subject.service");
    service.getSubjectAllByContent(contentId).then((response) => {
      const result = response.data;
      const subjectsData = result.map((item) => {
        return { label: item.subjectName, value: item.subjectId };
      });
      setSubjects(subjectsData);
      if (selectedItem) {
        setSelectedSubject(selectedItem);
      } else if (parameters?.autoFillData) {
        const selectedSubject = subjectsData.find((t) => {
          return t.value === parameters?.autoFillData.subjectId;
        });
        setSelectedSubject(selectedSubject);
      }
      setLoading(false);
    });
  }

  async function bindDomains(subjectId: number, selectedItem?: DropdownItem) {
    const service = await import("../../../api/domain.service");
    service.getAllDomainsBySubject(subjectId).then((response) => {
      setLoading(true);

      const result = response.data.data;
      const domainsData = result.map((item) => {
        return { label: item.name, value: item.domainId };
      });
      setDomains(domainsData);
      if (selectedItem) {
        setSelectedDomain(selectedItem);
      } else if (parameters?.autoFillData) {
        const selectedDomain = domainsData?.find((t) => {
          return t.value === parameters?.autoFillData?.domainId;
        });
        setSelectedDomain(selectedDomain);
      }

      setLoading(false);
    });
  }

  function handleContentAreaChange(selectedItem: any) {
    setSelectedContent(selectedItem);
    setSelectedSubject(defaultDropdownValues);
    setSelectedDomain(defaultDropdownValues);
    bindSubjects(selectedItem.value);
  }

  function handleSubjectChange(selectedItem: any) {
    setSelectedSubject(selectedItem);
    setSelectedDomain(defaultDropdownValues);
    bindDomains(selectedItem.value);
  }

  function handleDomainChange(e: any) {
    setSelectedDomain(e);
  }

  useEffect(() => {
    if (idToEdit) {
      setLoading(true);
      const standardGroupDetails = getStandardGroup(idToEdit);
      Promise.all([standardGroupDetails]).then(() => {
        standardGroupDetails.then((response) => {
          setLoading(false);

          const standardGroupData: any = response.data;
          setStandardGroupToEdit(standardGroupData);

          const selectedContent: any = standardGroupData
            ? {
                label: standardGroupData.contentAreaName,
                value: standardGroupData.contentAreaId,
              }
            : undefined;

          const selectedSubject: any = standardGroupData
            ? {
                label: standardGroupData.subjectName,
                value: standardGroupData.subjectId,
              }
            : undefined;

          const selectedDomain: any = standardGroupData
            ? {
                label: standardGroupData.domainName,
                value: standardGroupData.domainId,
              }
            : undefined;

          bindContentAreas(selectedContent);
          bindSubjects(standardGroupData.contentAreaId, selectedSubject);
          bindDomains(standardGroupData.subjectId, selectedDomain);
          filterStandards({ selectedContent, selectedSubject, selectedDomain });
        });
      });

      const groupStandardSearchReq: IStandardGroupStandardSearchRequest = {
        standardGroupId: idToEdit,
        standardId: 0,
        isActive: true,
      };

      getStandardGroupStandards(groupStandardSearchReq, 1, 99999).then(
        (response) => {
          if (response.data.data !== null) {
            setLoading(false);
            const groupStandards: any = response.data.data;
            const standardIds: Array<number> = groupStandards.map(
              (groupstandard) => {
                return groupstandard.standardId;
              }
            );
            setStandardGroupStandardIds(standardIds);
            setLoading(true);
          }
        }
      );
    } else {
      bindContentAreas();
      if (parameters?.autoFillData) {
        bindSubjects(parameters?.autoFillData?.contentId);
        bindDomains(parameters?.autoFillData?.subjectId);
      }
    }
  }, [id]);

  useEffect(() => {
    if (isLoaded) {
      filterStandards();
    }
  }, [pageNumber]);

  useEffect(() => {
    if (pageNumber == 1 && !isEdit) {
      filterStandards();
      setIsLoaded(true);
    } else {
      paginationRef?.current?.onReset();
    }
  }, [pageSize]);

  useEffect(() => {
    setIsLoaded(true);
  }, [isEdit]);

  useEffect(() => {
    if (isLoaded) {
      filterStandards();
    }
  }, [sortDir]);

  function handleRedirection(name: string, id: number) {
    if (name === "subject" && id) {
      navigate(constant.SUBJECTDETAIL.replace(":id", id.toString()), {
        state: { subjectType: 1 },
      });
    } else if (name && id) {
      navigate(`/${name}/edit/${id}`);
    } else {
      navigate(`/${name}`);
    }
  }

  async function handleSort(columnName) {
    setLoading(true);
    setOrderByColumn(columnName);
    setSortAscending(!sortAscending);
    setSortDir(sortAscending ? "DESC" : "ASC");
  }

  async function filterStandards(editData?) {
    setLoading(true);

    let names = "";
    if (selectedNames.length)
      selectedNames.map((ds) => {
        names += ".*|" + ds.label;
      });

    const standard: IStandard = {
      name: names,
      contentAreaId: editData
        ? editData.selectedContent.value
        : selectedContent !== null
        ? selectedContent.value
        : "0",
      subjectId: editData
        ? editData.selectedSubject.value
        : selectedSubject !== null
        ? selectedSubject.value
        : "0",
      domainId: "0",
      code: "",
      isActive: true,
      description: "",
      loadOrder: 0,
      pageSize: pageSize,
      pageNumber: pageNumber,
      orderbyColumn: orderByColumn,
      sortDir: sortAscending ? "DESC" : "ASC",
      standardId: filterStandardId,
    };

    const service = await import("../../../api/standard.service");
    service.getStandards(standard).then((response: any) => {
      setStandards(response.data.data);
      setTotalPages(Math.ceil(response.data.totalRecords / pageSize));
      setTotalRecords(response.data.totalRecords);
      setLoading(false);
      setIsEdit(false);
    });
  }

  function handleAddStandardGroupStandard(standardId: number) {
    if (standardGroupStandardIds.indexOf(standardId) !== -1) {
      toast.success("Standard already added");
      return;
    }
    const standardGroupStandard: IStandardGroupStandard = {
      standardGroupId: standardGroupToEdit?.standardGroupId ?? 0,
      standardId: standardId,
      isActive: true,
      createdByUserId:
        props.profile?.userId == undefined ? 1 : props.profile?.userId,
    };
    addNewStandard(standardGroupStandard).then((r) => {
      const standardIds = standardGroupStandardIds;
      standardIds.push(standardId);
      setStandardGroupStandardIds(standardIds);
      toast.success("Standard added successfully");
    });
  }

  return (
    <AllowedTo
      perform={[
        Permissions.standard_group_create,
        Permissions.standard_group_modify,
      ]}
      no={() => <AccessDenied />}
    >
      {loading && <Loader />}

      <div className="w-full">
        <div className="flex-1">
          <div className=" h-auto min-h-half w-full rounded-bl-3xl bg-site-teal px-8  py-8 pt-0 pb-14 mt-7 ">
            <div className="relative  py-1">
              <div className="overlay-image-main pointer-events-none fixed left-0 top-0 w-screen h-screen z-20"></div>
              <div className="flex items-center justify-between">
                <h3 className="text-lg font-light text-gray-900">
                  {id ? "Edit Standard Group " : "Add  Standard Group "}
                </h3>
              </div>
              <Breadcrumb items={breadcrumbItems()} />
              <div className="flex">
                <form
                  onSubmit={handleSubmit(submitHandler)}
                  className="w-2/5 mr-14"
                >
                  <div className="shadow py-6 border rounded-lg mt-4 px-4 w-full">
                    <div>
                      <div className="grid grid-cols-1 ">
                        <div>
                          <input
                            id="name"
                            defaultValue={standardGroupToEdit?.name}
                            type="text"
                            autoComplete="off"
                            className={`${
                              lang === 1 ? "" : "hidden"
                            } mt-1 w-full block border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-primary-color focus:border-primary-color dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-white sm:text-sm`}
                            {...register("name", {
                              required: true,
                              value: standardGroupToEdit?.name,
                            })}
                          />
                          {errors.name && errors.name.type == "required" && (
                            <span className="text-red-700 inline-block pt-1 text-sm">
                              Name is required
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="grid grid-cols-1 mt-5">
                        <div className="text-sm col-span-1 flex items-center ">
                          {selectedContent?.value !== "0" ? (
                            <a
                              className="text-gray-700 text-sm underline"
                              onClick={() =>
                                handleRedirection(
                                  "content-areas",
                                  parseInt(selectedContent?.value)
                                )
                              }
                              href={`/content-areas/edit/${parseInt(
                                selectedContent?.value
                              )}`}
                            >
                              Content Area
                            </a>
                          ) : (
                            <button className="text-gray-700 text-sm  cursor-default">
                              Content Area
                            </button>
                          )}
                        </div>
                        <div className="mt-1">
                          <Select
                            value={selectedContent}
                            onChange={handleContentAreaChange}
                            options={contentAreas}
                            className="text-gray-900 cursor-default select-none relative py-2"
                            isSearchable={true}
                            theme={(theme) => ({
                              ...theme,
                              colors: {
                                ...theme.colors,
                                primary25: "#B3B3B3",
                                primary: "#041E42",
                              },
                            })}
                            styles={{
                              control: (base, state) => ({
                                ...base,
                                background:
                                  document.getElementsByClassName("dark")
                                    ?.length > 0
                                    ? "#1A1C23"
                                    : "white",
                                borderColor:
                                  document.getElementsByClassName("dark")
                                    ?.length > 0
                                    ? "#6B7280"
                                    : "#D1D5DB",
                                borderWidth: "1px",
                                "&:hover": {
                                  borderColor:
                                    state.isFocused &&
                                    document.getElementsByClassName("dark")
                                      ?.length > 0
                                      ? "#6b7280"
                                      : state.isFocused
                                      ? "#4c5563"
                                      : "",
                                },
                              }),
                              singleValue: (base) => ({
                                ...base,
                                color:
                                  document.getElementsByClassName("dark")
                                    ?.length > 0
                                    ? "white"
                                    : "#374051",
                              }),
                              input: (base) => ({
                                ...base,
                                color:
                                  document.getElementsByClassName("dark")
                                    ?.length > 0
                                    ? "white"
                                    : "",
                              }),
                            }}
                          />
                        </div>
                      </div>

                      <div className="grid grid-cols-1 mt-5">
                        <div className="text-sm col-span-1 flex items-center ">
                          {selectedSubject?.value !== "0" ? (
                            <a
                              className="text-gray-700 text-sm underline"
                              onClick={() =>
                                handleRedirection(
                                  "subject",
                                  parseInt(selectedSubject?.value)
                                )
                              }
                              href={constant.SUBJECTDETAIL.replace(
                                ":id",
                                selectedSubject?.value.toString()
                              )}
                            >
                              Subject
                            </a>
                          ) : (
                            <button className="text-gray-700 text-sm cursor-default">
                              Subject
                            </button>
                          )}
                        </div>
                        <div className="mt-1">
                          <Select
                            value={selectedSubject}
                            onChange={handleSubjectChange}
                            options={subjects}
                            className="text-gray-900 cursor-default select-none relative py-2"
                            isSearchable={true}
                            theme={(theme) => ({
                              ...theme,
                              colors: {
                                ...theme.colors,
                                primary25: "#B3B3B3",
                                primary: "#041E42",
                              },
                            })}
                            styles={{
                              control: (base, state) => ({
                                ...base,
                                background:
                                  document.getElementsByClassName("dark")
                                    ?.length > 0
                                    ? "#1A1C23"
                                    : "white",
                                borderColor:
                                  document.getElementsByClassName("dark")
                                    ?.length > 0
                                    ? "#6B7280"
                                    : "#D1D5DB",
                                borderWidth: "1px",
                                "&:hover": {
                                  borderColor:
                                    state.isFocused &&
                                    document.getElementsByClassName("dark")
                                      ?.length > 0
                                      ? "#6b7280"
                                      : state.isFocused
                                      ? "#4c5563"
                                      : "",
                                },
                              }),
                              singleValue: (base) => ({
                                ...base,
                                color:
                                  document.getElementsByClassName("dark")
                                    ?.length > 0
                                    ? "white"
                                    : "#374051",
                              }),
                              input: (base) => ({
                                ...base,
                                color:
                                  document.getElementsByClassName("dark")
                                    ?.length > 0
                                    ? "white"
                                    : "",
                              }),
                            }}
                          />
                        </div>
                      </div>

                      <div className="grid grid-cols-1 mt-5">
                        <div className="text-sm col-span-1flex items-center ">
                          {selectedDomain?.value !== "0" ? (
                            <a
                              className="text-gray-700 text-sm underline"
                              onClick={() =>
                                handleRedirection(
                                  "domains",
                                  parseInt(selectedDomain?.value)
                                )
                              }
                              href={`/domains/edit/${parseInt(
                                selectedDomain?.value
                              )}`}
                            >
                              Domain
                            </a>
                          ) : (
                            <button className="text-gray-700 text-sm cursor-default">
                              Domain
                            </button>
                          )}
                        </div>
                        <div className="mt-1">
                          <Select
                            value={selectedDomain}
                            onChange={handleDomainChange}
                            options={domains}
                            className="text-gray-900 cursor-default select-none relative py-2"
                            isSearchable={true}
                            theme={(theme) => ({
                              ...theme,
                              colors: {
                                ...theme.colors,
                                primary25: "#B3B3B3",
                                primary: "#041E42",
                              },
                            })}
                            styles={{
                              control: (base, state) => ({
                                ...base,
                                background:
                                  document.getElementsByClassName("dark")
                                    ?.length > 0
                                    ? "#1A1C23"
                                    : "white",
                                borderColor:
                                  document.getElementsByClassName("dark")
                                    ?.length > 0
                                    ? "#6B7280"
                                    : "#D1D5DB",
                                borderWidth: "1px",
                                "&:hover": {
                                  borderColor:
                                    state.isFocused &&
                                    document.getElementsByClassName("dark")
                                      ?.length > 0
                                      ? "#6b7280"
                                      : state.isFocused
                                      ? "#4c5563"
                                      : "",
                                },
                              }),
                              singleValue: (base) => ({
                                ...base,
                                color:
                                  document.getElementsByClassName("dark")
                                    ?.length > 0
                                    ? "white"
                                    : "#374051",
                              }),
                              input: (base) => ({
                                ...base,
                                color:
                                  document.getElementsByClassName("dark")
                                    ?.length > 0
                                    ? "white"
                                    : "",
                              }),
                            }}
                          />
                        </div>
                      </div>

                      <div className="flex justify-end mt-8 items-center border-t ">
                        <button
                          type="submit"
                          className="inline-flex items-center px-3 py-2 my-3 hover:bg-secondary-color border border-transparent text-sm leading-4 font-medium rounded-md shadow-sm text-white dark:text-white bg-primary-color  focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color"
                        >
                          {id ? "Update " : "Save"}
                        </button>
                        <Link to={constant.STANDARDGROUPS} className="ml-2">
                          <button className="inline-flex items-center px-3 py-2 my-3 hover:text-gray-500 border border-gray-300 text-sm leading-4 font-medium rounded-md shadow-sm text-gray-700 bg-white  focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color">
                            Cancel
                          </button>
                        </Link>
                      </div>
                    </div>
                  </div>
                </form>
                {id && (
                  <div id="dataContainer" className="mt-4 w-full">
                    <div>
                      <button
                        type="submit"
                        className="py-1.5 px-4 inline-flex items-center text-sm rounded-lg text-gray-700 text-primary-color border border-gray-300 gap-2 bg-white hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color "
                        onClick={() => filterStandards()}
                      >
                        <FilterIcon className="w-3 h-3"></FilterIcon>
                        <span>Filter Standards</span>
                      </button>
                    </div>
                    <div className="flex flex-col mt-2">
                      <div className="-my-2 sm:-mx-6 lg:-mx-8">
                        <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                          <div className="shadow border-b border-gray-200 sm:rounded-lg">
                            <table className="min-w-full divide-y divide-gray-200">
                              <thead className="bg-primary-color">
                                <tr>
                                  <th className="w-8 rounded-tl-lg"></th>
                                  <th
                                    scope="col"
                                    className="px-3 py-2 pl-6 font-light text-sm text-left text-white dark:text-white tracking-wider w-32"
                                  >
                                    <span className="flex gap-2">
                                      Id
                                      <span className="cursor-pointer">
                                        {!sortAscending &&
                                        orderByColumn === "standardId" ? (
                                          <CaretUpSolidIcon
                                            onClick={() =>
                                              handleSort("standardId")
                                            }
                                            className="w-5 h-5"
                                          ></CaretUpSolidIcon>
                                        ) : (
                                          <CaretDownSolidIcon
                                            onClick={() =>
                                              handleSort("standardId")
                                            }
                                            className="w-5 h-5"
                                          ></CaretDownSolidIcon>
                                        )}
                                      </span>
                                    </span>
                                  </th>
                                  <th
                                    scope="col"
                                    className="px-3 py-2 font-light whitespace-wrap text-sm text-left text-white dark:text-white "
                                  >
                                    <span className="flex gap-2">
                                      Code
                                      <span className="cursor-pointer">
                                        {!sortAscending &&
                                        orderByColumn === "code" ? (
                                          <CaretUpSolidIcon
                                            onClick={() => handleSort("code")}
                                            className="w-5 h-5"
                                          ></CaretUpSolidIcon>
                                        ) : (
                                          <CaretDownSolidIcon
                                            onClick={() => handleSort("code")}
                                            className="w-5 h-5"
                                          ></CaretDownSolidIcon>
                                        )}
                                      </span>
                                    </span>
                                  </th>
                                  <th
                                    scope="col"
                                    className="px-3 py-2 pl-6 font-light text-sm text-left text-white dark:text-white tracking-wider"
                                  >
                                    <span className="flex gap-2">
                                      Name
                                      <span className="cursor-pointer">
                                        {!sortAscending &&
                                        orderByColumn === "name" ? (
                                          <CaretUpSolidIcon
                                            onClick={() => handleSort("name")}
                                            className="w-5 h-5"
                                          ></CaretUpSolidIcon>
                                        ) : (
                                          <CaretDownSolidIcon
                                            onClick={() => handleSort("name")}
                                            className="w-5 h-5"
                                          ></CaretDownSolidIcon>
                                        )}
                                      </span>
                                    </span>
                                  </th>
                                  <th
                                    scope="col"
                                    className="px-3 py-2 pl-6 font-light text-sm text-left text-white dark:text-white tracking-wider"
                                  >
                                    Domain
                                  </th>
                                  <th
                                    scope="col"
                                    className="px-3 py-2 font-light text-sm text-center text-white dark:text-white tracking-wider rounded-tr-lg"
                                  ></th>
                                </tr>
                              </thead>
                              <tbody>
                                {standards.map((standard: any, index) => (
                                  <tr
                                    key={standard.standardId}
                                    className={
                                      index % 2 === 0
                                        ? "bg-white"
                                        : "bg-gray-100"
                                    }
                                  >
                                    <td className="pl-5 relative w-8">
                                      {standard.isActive ? (
                                        <span className="mr-1 h-4/5 w-0.5 bg-green-500 rounded-md inline-block absolute top-0 left-1.5"></span>
                                      ) : (
                                        <span className="mr-1 h-4/5 w-0.5 bg-red-500 rounded-md inline-block absolute top-0 left-1.5"></span>
                                      )}
                                      {standard.isLinked && (
                                        <LinkIcon
                                          className={`cursor-not-allowed w-5 ${
                                            standard.isLinked
                                              ? ""
                                              : "opacity-50"
                                          }`}
                                        />
                                      )}
                                    </td>
                                    <td className="px-3 py-2  pl-6 whitespace-wrap text-sm text-left font-normal text-gray-500 ">
                                      <Link
                                        to={Constant.EDITSTANDARD.replace(
                                          ":id",
                                          standard.standardId
                                            ? standard.standardId.toString()
                                            : ""
                                        )}
                                        className="cursor-pointer font-medium text-indigo-600 hover:text-indigo-500 hover:underline"
                                      >
                                        {standard.standardId}
                                      </Link>
                                    </td>
                                    <td className="px-3 py-2 whitespace-wrap text-sm text-left font-normal text-gray-500">
                                      {standard.code}
                                    </td>
                                    <td className="px-3 py-2  pl-6 whitespace-wrap text-sm text-left font-normal text-gray-500">
                                      <div className="flex items-center">
                                        {standard.standardIcon && (
                                          <img
                                            className="h-5 w-5 mr-2"
                                            src={standard.standardIcon}
                                          />
                                        )}
                                        {standard.name}
                                      </div>
                                    </td>
                                    <td className="px-3 py-2  pl-6 whitespace-wrap text-sm text-left font-normal text-gray-500">
                                      <Link
                                        to={Constant.EDITDOMAIN.replace(
                                          ":id",
                                          standard.domainId
                                            ? standard.domainId.toString()
                                            : ""
                                        )}
                                        className="cursor-pointer font-medium text-indigo-600 hover:text-indigo-500 hover:underline"
                                      >
                                        {standard.domainName}
                                      </Link>
                                    </td>
                                    <td>
                                      {standardGroupStandardIds.indexOf(
                                        standard.standardId
                                      ) === -1 && (
                                        <AddIcon
                                          onClick={() => {
                                            handleAddStandardGroupStandard(
                                              standard.standardId
                                            );
                                          }}
                                          className="w-5 cursor-pointer text-gray-500 hover:text-gray-700"
                                        />
                                      )}
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                      <div
                        className={`flex justify-between items-center ${
                          standards.length === 0 ? "hidden" : ""
                        }`}
                      >
                        <Pagination
                          pages={totalPages}
                          setPageNumber={setPageNumber}
                          ref={paginationRef}
                        />
                        <span>
                          <span className="text-sm pr-4 ml-auto text-left-700">
                            Showing {pageNumber} to{" "}
                            {totalRecords < pageSize ? totalRecords : pageSize}{" "}
                            of {totalRecords} results
                          </span>

                          <SelectPageSize
                            setPageSize={setPageSize}
                            type={"second"}
                            ref={pageSizeRef}
                          />
                        </span>
                      </div>

                      {standards.length === 0 && (
                        <p className="p-2">No Records Found</p>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </AllowedTo>
  );
};

const mapStateToProps = (state: any) => {
  return {
    profile: state.profile,
  };
};

export default ManageStandardGroup;
